import { render, staticRenderFns } from "./GSKPDF.vue?vue&type=template&id=8eb71dd4&scoped=true&"
import script from "./GSKPDF.vue?vue&type=script&lang=ts&"
export * from "./GSKPDF.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb71dd4",
  null
  
)

export default component.exports